import { render, staticRenderFns } from "./EventRecordAdd.vue?vue&type=template&id=e1d050f2&scoped=true"
import script from "./EventRecordAdd.vue?vue&type=script&lang=js"
export * from "./EventRecordAdd.vue?vue&type=script&lang=js"
import style0 from "./EventRecordAdd.vue?vue&type=style&index=0&id=e1d050f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d050f2",
  null
  
)

export default component.exports